/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import 'modules/dashboard/styles.css';

import useHome from './hooks/useHome';
import Box from 'v2/components/UI/Box';
import DashboardSummaryItems from './components/DashboardSummaryItems';
import Filters from './components/Filters';
import HashLoading from 'v2/components/UI/Loading/Hash';
import CardNursery from './components/CardNursery';
import Cycles from './components/Cycles';
import { INursery } from 'v2/resources/types/nurseries';
import { ICycle } from 'v2/resources/types/cycles';
import Text from 'v2/components/UI/Text';
import Icon from 'v2/components/Icon';

const Home: React.FC = () => {
  const {
    dashboardLoading,
    nurserySelected,
    nurseries,
    cycles,

    loading,
    cost,
    fca,
    harvestBiomass,
    mainSurvivalText,
    survival,
  } = useHome();

  const renderNurseriesOrMessageEmpty = () => {
    if (nurseries.length === 0) {
      return (
        <Box
          width="100%"
          padding={20}
          borderRadius={16}
          textAlign="left"
          flexDirection="column"
          gap={2}
          background={'#fbe9e7'}
        >
          <Icon iconName="ErrorOutlineOutlined" size={34} htmlColor="#5f1300" />
          <Text color="#5f1300" fontSize={18} fontWeight={500}>
            Não há viveiros disponíveis para exibir.
          </Text>
          <Text color="#5f1300" fontSize={20} fontWeight={600}>
            Por favor, verifique se há viveiros cadastrados ou se os filtros
            aplicados estão corretos.
          </Text>
        </Box>
      );
    }

    return nurseries.map((nursery: INursery, index: number) => (
      <CardNursery index={index} cycles={cycles} {...nursery} />
    ));
  };

  const renderCyclesOrMessageEmpty = () => {
    if (cycles.length === 0) {
      return (
        <Box
          width="100%"
          padding={20}
          borderRadius={16}
          textAlign="left"
          flexDirection="column"
          gap={2}
          background={'#fbe9e7'}
        >
          <Icon iconName="ErrorOutlineOutlined" size={34} htmlColor="#5f1300" />
          <Text color="#5f1300" fontSize={18} fontWeight={500}>
            Não há ciclos disponíveis para exibir.
          </Text>
          <Text color="#5f1300" fontSize={20} fontWeight={600}>
            Por favor, verifique se há ciclos cadastrados ou se os filtros
            aplicados estão corretos.
          </Text>
        </Box>
      );
    }

    return cycles.map((cycle: ICycle) => <Cycles {...cycle} />);
  };

  const renderContent = () => {
    if (nurserySelected) {
      return (
        <Box width="100%" gap={'2%'} flexWrap="wrap" marginTop={20}>
          {renderNurseriesOrMessageEmpty()}
        </Box>
      );
    }
    return (
      <Box width="100%" gap={20} flexDirection="column" marginTop={20}>
        {renderCyclesOrMessageEmpty()}
      </Box>
    );
  };

  const renderLoadingOrContent = () => {
    if (dashboardLoading) {
      return (
        <Box flex={1}>
          <HashLoading size={100} />
        </Box>
      );
    }

    return renderContent();
  };

  return (
    <Box
      flexDirection="column"
      gap={20}
      width="100%"
      alignItems="center"
      justifyContent="center"
      boxSizing="border-box"
      padding={10}
    >
      <DashboardSummaryItems
        loading={loading}
        cost={cost}
        fca={fca}
        harvestBiomass={harvestBiomass}
        mainSurvivalText={mainSurvivalText}
        survival={survival}
      />

      <Filters />

      {renderLoadingOrContent()}

      {/* <ModalInsights
        isOpen={showModalInsights}
        data={dataModalInsights}
        onClose={handleCloseModalInsights}
      /> */}
    </Box>
  );
};

export default Home;
